import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { flightSearchesStore } from 'widgets/avia'
import { SearchFormCopy } from 'widgets/avia/search-form-copy'
import { CountAndClass } from 'widgets/level-class-count'

import findTicketFormStore from 'entities/ticket/models/find-ticket/find-ticket-store'

import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

const SearchFormPage = observer(() => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const onChangeSearch = (data?: CountAndClass) => {
    findTicketFormStore.onSetCountAndClass(data, true)
  }

  const onSwitchDirection = () => {
    findTicketFormStore.onSwitchDirectionCopy(0)
  }

  const onSearch = () => {
    findTicketFormStore.setCopyForSearch()

    navigate(RoutingPaths.avia.search.path())
  }

  const onGoBack = () => {
    findTicketFormStore.resetDirectionCopy()

    navigate(-1)
  }

  useEffect(() => {
    void flightSearchesStore.ensureSearches()

    !findTicketFormStore?.copyFormFindTicket &&
      findTicketFormStore.onSetDataCopy()
  }, [])

  return (
    <div className={clsx('container', s.container)}>
      <div className={s.header}>
        <HeaderGoBack
          title={t('edit_search')}
          onGoBack={onGoBack}
          buttonWhite
        />
      </div>

      <Paper padding={[16]}>
        <div className={s.box}>
          <p className={s.title}>{t('main_page.title')}</p>

          <p className={s.subTitle}>{t('main_page.sub_title')}</p>
        </div>

        <SearchFormCopy
          type={'lightGrey'}
          isSearch
          onSearch={onSearch}
          onChange={onChangeSearch}
          onSwitch={onSwitchDirection}
          searchData={findTicketFormStore.copyFormFindTicket || {}}
        />
      </Paper>
    </div>
  )
})

export default SearchFormPage
